import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1072.58824,960 C1072.58824,1127.26588 1168.81412,1205.30824 1261.87765,1280.64 C1378.43294,1375.17176 1509.67059,1481.56235 1523.22353,1807.05882 L396.070588,1807.05882 C409.623529,1481.56235 540.861176,1375.17176 657.416471,1280.64 C750.48,1205.30824 846.705882,1127.26588 846.705882,960 C846.705882,792.734118 750.48,714.691765 657.416471,639.36 C540.861176,544.828235 409.623529,438.437647 396.070588,112.941176 L1523.22353,112.941176 C1509.67059,438.437647 1378.43294,544.828235 1261.87765,639.36 C1168.81412,714.691765 1072.58824,792.734118 1072.58824,960 M1333.03059,727.002353 C1468.56,617.110588 1637.29412,480.338824 1637.29412,56.4705882 L1637.29412,0 L282,0 L282,56.4705882 C282,480.338824 450.734118,617.110588 586.263529,727.002353 C675.035294,799.058824 733.764706,846.607059 733.764706,960 C733.764706,1073.39294 675.035294,1120.94118 586.263529,1192.99765 C450.734118,1302.88941 282,1439.66118 282,1863.52941 L282,1920 L1637.29412,1920 L1637.29412,1863.52941 C1637.29412,1439.66118 1468.56,1302.88941 1333.03059,1192.99765 C1244.25882,1120.94118 1185.52941,1073.39294 1185.52941,960 C1185.52941,846.607059 1244.25882,799.058824 1333.03059,727.002353 M933.84,1274.66541 L764.202353,1412.34071 C689.887059,1472.53835 625.849412,1524.37835 591.515294,1637.65835 L1327.77882,1637.65835 C1293.44471,1524.37835 1229.40706,1472.53835 1155.09176,1412.34071 L985.454118,1274.66541 C970.432941,1262.46776 948.861176,1262.46776 933.84,1274.66541",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconHourGlassLine = /*#__PURE__*/function (_Component) {
  _inherits(IconHourGlassLine, _Component);

  var _super = _createSuper(IconHourGlassLine);

  function IconHourGlassLine() {
    _classCallCheck(this, IconHourGlassLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconHourGlassLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconHourGlass",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconHourGlassLine.displayName = "IconHourGlassLine";
  return IconHourGlassLine;
}(Component);

IconHourGlassLine.glyphName = 'hour-glass';
IconHourGlassLine.variant = 'Line';
IconHourGlassLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconHourGlassLine;
export { IconHourGlassLine };